import _ from "underscore";
import * as config from "../framework/config";
import * as Utils from "./utils";

function getUrl(path) {
    return config.get("surveys.url") + path
}

export function getSurveys(data, query) {
    const url = config.get("surveys.url") + "/summaries",
        _data = _.extend({}, query, data);
    return Utils.get(url, _data);
}

export function createSurvey(data) {
    const url = config.get("surveys.url");

    return Utils.post(url, data);
}

export function getQuestionsTree(data) {
    const url = config.get("surveys.url") + `/${data.id}/questions-tree`;

    return Utils.get(url);
}

export function getSurveyRatings(data) {
    const url = config.get("surveys.url") + `/${data.id}/ratings`;

    return Utils.get(url);
}

export function setSurveyRating(data) {
    const url = config.get("surveys.url") + `/${data.surveyId}/ratings`;

    return Utils.post(url, data);
}

export function setSurveyRatingNotes(data) {
    const url = config.get("surveys.url") + `/${data.surveyId}/ratings/set-notes`;

    return Utils.post(url, data);
}

export function getSurveyScores(data) {
    const url = config.get("surveys.url") + `/${data.id}/scores`;

    return Utils.get(url);
}

export function getSurveyUsers(data) {
    const url = config.get("surveys.url") + `/${data.id}/online-users`;

    return Utils.get(url);
}

export function closeSurvey(data) {
    const url = config.get("surveys.url") + `/${data.id}/close`;

    return Utils.post(url);
}

export function reopenSurvey(data) {
    const url = config.get("surveys.url") + `/${data.id}/reopen`;

    return Utils.post(url);
}

export function addPhoto(data) {
    const url = config.get("surveys.url") + `/${data.surveyId}/ratings/add-photo`;
    
    return Utils.postMultipart(url, data);
}

export function removePhoto(data) {
    const url = config.get("surveys.url") + `/${data.surveyId}/ratings/${data.ratingId}/photos/${data.photoId}`;

    return Utils.delete_(url);
}

export function getSurveysStats() {
    const url = config.get("surveys.url") + "/stats";
    return Utils.get(url);
}